module.exports = __webpack_public_path__ + "img/wsj.3d0f7c09.png";